const INITIAL_STORE_ADDRESS: ParsedAddress = {
	address1: "",
	address2: "",
	city: "",
	stateCode: "",
	stateName: "",
	zipCode: "",
	countryCode: "",
	countryName: "",
};

export { INITIAL_STORE_ADDRESS };
